var map = {
	"./1.jpg": 38,
	"./2.jpg": 57,
	"./3.jpg": 708,
	"./4.jpg": 119,
	"./5.jpg": 962,
	"./6.jpg": 453,
	"./7.jpg": 272,
	"./8.jpg": 771,
	"./9.jpg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 699;